/** "Meus impulsionamentos": o que foi criado por aqui, com o estado de cada um. */

import { Link, useLocation } from "wouter";
import { trpc } from "@/lib/trpc";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ExternalLink, Rocket } from "lucide-react";
import { moeda } from "@/lib/meta-ads-format";
import { OBJETIVOS_IMPULSIONAR, type ObjetivoImpulsionar } from "@shared/meta-ads-boost";
import { tempoRelativo } from "@/lib/tempo";

const STATUS: Record<string, { label: string; cls: string }> = {
  creating: { label: "Criando", cls: "bg-blue-100 text-blue-800" },
  partial: { label: "Incompleto", cls: "bg-amber-100 text-amber-800" },
  paused: { label: "Pausado", cls: "bg-slate-100 text-slate-700" },
  active: { label: "No ar", cls: "bg-emerald-100 text-emerald-800" },
  failed: { label: "Falhou", cls: "bg-red-100 text-red-800" },
};

export function BoostsCard({ canManage }: { canManage: boolean }) {
  const [, navigate] = useLocation();
  const lista = trpc.metaAds.boost.list.useQuery({ limit: 10 }, { staleTime: 30_000 });
  if (!lista.data || lista.data.length === 0) return null;
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="flex items-center gap-2 font-medium"><Rocket className="h-4 w-4" /> Meus impulsionamentos</h2>
          {canManage && <Button size="sm" variant="outline" onClick={() => navigate("/ads/new")}>Novo</Button>}
        </div>
        <div className="space-y-2">
          {lista.data.map((b) => {
            const st = STATUS[b.status] ?? { label: b.status, cls: "" };
            const obj = OBJETIVOS_IMPULSIONAR[b.objectiveKey as ObjetivoImpulsionar]?.label ?? b.objectiveKey;
            return (
              <div key={b.id} className="flex items-center gap-3 rounded border p-2 text-sm">
                {b.sourceThumbUrl ? <img src={b.sourceThumbUrl} alt="" className="h-10 w-10 rounded object-cover" /> : <div className="h-10 w-10 rounded bg-muted" />}
                <div className="min-w-0 flex-1">
                  <p className="truncate font-medium">
                    {b.campaignId ? <Link href={`/ads/campaigns/${b.campaignId}`} className="hover:underline">{b.name}</Link> : b.name}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {obj} · {moeda(b.dailyBudgetCents, b.currency)}/dia · {tempoRelativo(b.createdAt)}
                    {b.lastError && b.status === "partial" && <span className="text-amber-700"> · parou em: {b.lastError.slice(0, 80)}</span>}
                  </p>
                </div>
                <span className={`rounded px-1.5 py-0.5 text-[10px] font-medium ${st.cls}`}>{st.label}</span>
                {b.sourceIgPermalink && (
                  <a href={b.sourceIgPermalink} target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-foreground" title="Ver post">
                    <ExternalLink className="h-4 w-4" />
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
